import script from "./PopupTool6.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupTool6.vue?vue&type=script&setup=true&lang=js"

import "./PopupTool6.vue?vue&type=style&index=0&id=16e8b0f6&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/u.xiansuotu.com/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16e8b0f6"]])

export default __exports__